import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { capitalizeSentence } from '../../../../utils/usefulFunctions';
import { getCSSVariable } from '../../../../stylesheets/cssVariablesUtils';
import useTranslate from '../../../../customHooks/useTranslate';

const SearchSelect = ({
    options,
    label,
    onChange,
    optionTextKey,
    name,
    valueKey = 'Id',
    ...restProps
}) => {
    const translate = useTranslate();

    const isOptionEqualToValue = (option, currentValue) =>
        option[valueKey] === currentValue[valueKey];

    const autocompleteSx = {
        '& label.Mui-focused': {
            color: getCSSVariable('jungleGreen'),
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: getCSSVariable('jungleGreen'),
            },
            '&.Mui-focused fieldset': {
                borderColor: getCSSVariable('jungleGreen'),
            },
        },
        '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: `${getCSSVariable('greenSelected')} !important`,
        },
        '& .MuiAutocomplete-option[aria-selected="true"]:hover': {
            backgroundColor: `${getCSSVariable(
                'greenSelectedDark'
            )} !important`,
        },
    };

    return (
        <Autocomplete
            options={options}
            size='small'
            getOptionLabel={option => option[optionTextKey]}
            isOptionEqualToValue={isOptionEqualToValue}
            sx={autocompleteSx}
            renderInput={params => (
                <TextField
                    label={capitalizeSentence(translate(label))}
                    {...params}
                />
            )}
            {...restProps}
            onChange={(event, ...rest) =>
                onChange(
                    {
                        ...event,
                        target: {
                            ...event.target,
                            name,
                        },
                    },
                    ...rest
                )
            }
        />
    );
};

export default SearchSelect;
